import React from 'react'

export default function MiniTesti(props) {
  return (
   <div className="monial">
    <div className="min">
        <i>{props.comment}</i>
        <div className="in">
            <img src={props.image} style={{height:"60px",width:"60px",borderRadius:"50%",border:"1px solid black"}}></img>
            <div className="out">
                <h3>{props.name}</h3>
                <p>{props.profession}</p>
            </div>
        </div>
    </div>
   </div>
  )
}
